module.exports = __webpack_public_path__ + "img/cardBg.dd23482b.png";